import BasicLayout from '@/layouts/basic-layout'

const prefix = 'summary-receivable-statement-'
export default {
  path: '/report-center/summary-receivable-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {cache: true, title: '应收实收汇总报表'},
      component: () => import('@/pages/report-center/summary-receivable-statement/index')
    },
  ]
}
